export const EMAIL_CONTACT = 'chira_ceo@onlystory.co.jp'
export const TEL_CONTACT = '03-6821-7872'

export const SITE_TITLE = 'ONLY STORY'
export const SITE_AUTHOR = 'ONLY STORY inc.'
export const DEFAULT_PAGE_TITLE = '決裁者のつながりプラットフォーム'
export const DEFAULT_DESCRPIPTION =
  'ONLY STORYは、決裁者のつながりプラットフォームです。口コミや評判だけでは伝わらない、決裁者1人1人のストーリーを読み、その後決裁者同士でつながることができます。'
export const DEFAULT_IMAGE = 'https://assets.onlystory.co.jp/images/logo2.png'
export const DEFAULT_TYPE = 'website'

export const APP_ICON_SRC =
  'https://is4-ssl.mzstatic.com/image/thumb/Purple114/v4/58/9b/f9/589bf9ad-8691-8c9b-fd03-a6eb145b9b6d/AppIcon-0-0-1x_U007emarketing-0-0-0-7-0-0-sRGB-0-0-0-GLES2_U002c0-512MB-85-220-0-0.png/1200x1200bb.jpg'
export const PLAY_STORE_ICON_SRC =
  'https://play.google.com/intl/us-en/badges/static/images/badges/ja_badge_web_generic.png'
export const APP_STORE_ICON_SRC =
  'https://tools.applemediaservices.com/api/badges/download-on-the-app-store/black/ja-JP?size=250x83&amp;releaseDate=1610064000&h=d464ba2d581fa48af0a9386ace14bc5a'
export const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.onlystory.onlystoryapp&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'
export const APP_STORE_URL =
  'https://apps.apple.com/us/app/%E3%82%AA%E3%83%B3%E3%83%AA%E3%83%BC%E3%82%B9%E3%83%88%E3%83%BC%E3%83%AA%E3%83%BC/id1544702467?itsct=apps_box&amp;itscg=30200'
